import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["slideFooter"],
    _excluded2 = ["render", "captions", "styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { createModule, MODULE_CONTROLLER, PLUGIN_CAPTIONS } from "../../core/index.js";
import { CaptionsContextProvider } from "./CaptionsContext.js";
import { Description } from "./Description.js";
import { Title } from "./Title.js";
export var defaultCaptionsProps = {
  descriptionTextAlign: "start",
  descriptionMaxLines: 3
};
export var Captions = function Captions(_ref) {
  var augment = _ref.augment,
      addParent = _ref.addParent;
  addParent(MODULE_CONTROLLER, createModule(PLUGIN_CAPTIONS, CaptionsContextProvider));
  augment(function (_ref2) {
    var _ref2$render = _ref2.render,
        renderFooter = _ref2$render.slideFooter,
        restRender = _objectWithoutProperties(_ref2$render, _excluded),
        captions = _ref2.captions,
        styles = _ref2.styles,
        restProps = _objectWithoutProperties(_ref2, _excluded2);

    return _objectSpread({
      render: _objectSpread({
        slideFooter: function slideFooter(slide) {
          return React.createElement(React.Fragment, null, renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter(slide), slide.title && React.createElement(Title, {
            styles: styles,
            title: slide.title
          }), slide.description && React.createElement(Description, _objectSpread({
            styles: styles,
            description: slide.description
          }, _objectSpread(_objectSpread({}, defaultCaptionsProps), captions))));
        }
      }, restRender),
      styles: styles
    }, restProps);
  });
};